import React, { useState } from 'react';
import { ProjectCard } from '../components/ProjectCard';
import { Button } from '../components/ui/Button';
import { Award, Briefcase, Home, Building } from 'lucide-react';
import { SEOSchema } from '../components/SEOSchema';
import { useLanguage } from '../contexts/LanguageContext';
export function ProjectsPage() {
  const {
    t,
    language
  } = useLanguage();
  const [filter, setFilter] = useState(t('Semua', 'All'));
  const filters = [t('Semua', 'All'), t('Rumah Subsidi', 'Subsidized Housing'), t('Rumah Premium', 'Premium Residences'), t('Komersial', 'Commercial'), t('Berjalan', 'Ongoing')];
  const projects = [
  // FASE I - PERINTISAN & HUNIAN SUBSIDI (2005-2010)
  {
    title: 'Graha Garuda Permai',
    location: 'Garuda Sakti KM 3, Pekanbaru',
    status: t('Selesai', 'Completed') as any,
    type: t('Rumah Subsidi', 'Subsidized Housing'),
    units: '477',
    year: '2005',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Graha Suka Makmur',
    location: 'Kampar, Riau',
    status: t('Selesai', 'Completed') as any,
    type: t('Rumah Subsidi', 'Subsidized Housing'),
    units: '208',
    year: '2006',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Graha Taman Anggrek',
    location: 'Garuda Sakti KM 2, Pekanbaru',
    status: t('Selesai', 'Completed') as any,
    type: t('Rumah Subsidi', 'Subsidized Housing'),
    units: '140',
    year: '2008',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Graha Suka Makmur 2',
    location: 'Kampar, Riau',
    status: t('Selesai', 'Completed') as any,
    type: t('Rumah Subsidi', 'Subsidized Housing'),
    units: '91',
    year: '2008',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Graha Arengka Permai',
    location: 'Siak Hulu, Kampar',
    status: t('Selesai', 'Completed') as any,
    type: t('Rumah Subsidi', 'Subsidized Housing'),
    units: '52',
    year: '2009',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Rowo Bening Cluster',
    location: 'Tampan, Pekanbaru',
    status: t('Selesai', 'Completed') as any,
    type: t('Rumah Subsidi', 'Subsidized Housing'),
    units: '41',
    year: '2009',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Graha Bening Permai',
    location: 'Tampan, Pekanbaru',
    status: t('Selesai', 'Completed') as any,
    type: t('Rumah Subsidi', 'Subsidized Housing'),
    units: '72',
    year: '2010',
    imageColor: 'bg-neutral-100'
  },
  // FASE II - EKSPANSI & DIVERSIFIKASI (2011-2014)
  {
    title: 'Hotel Aziza',
    location: 'Pekanbaru, Riau',
    status: t('Selesai', 'Completed') as any,
    type: t('Komersial', 'Commercial'),
    units: '12',
    year: '2011',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Ruko Melati Athaya',
    location: 'Pekanbaru, Riau',
    status: t('Selesai', 'Completed') as any,
    type: t('Komersial', 'Commercial'),
    units: '11',
    year: '2012',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Kios Graha Bening Permai',
    location: 'Tampan, Pekanbaru',
    status: t('Selesai', 'Completed') as any,
    type: t('Komersial', 'Commercial'),
    units: '17',
    year: '2012',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Graha Bening Permai II',
    location: 'Tampan, Pekanbaru',
    status: t('Selesai', 'Completed') as any,
    type: t('Rumah Subsidi', 'Subsidized Housing'),
    units: '45',
    year: '2012',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Villa Padma I',
    location: 'Pekanbaru, Riau',
    status: t('Selesai', 'Completed') as any,
    type: t('Rumah Premium', 'Premium Residence'),
    units: '75',
    year: '2013',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Villa Air Dingin',
    location: 'Pekanbaru, Riau',
    status: t('Selesai', 'Completed') as any,
    type: t('Rumah Premium', 'Premium Residence'),
    units: '8',
    year: '2014',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Villa Padma II',
    location: 'Pekanbaru, Riau',
    status: t('Selesai', 'Completed') as any,
    type: t('Rumah Premium', 'Premium Residence'),
    units: '46',
    year: '2014',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Ruko UKA',
    location: 'Pekanbaru, Riau',
    status: t('Selesai', 'Completed') as any,
    type: t('Komersial', 'Commercial'),
    units: '16',
    year: '2014',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Ruko Surabaya',
    location: 'Pekanbaru, Riau',
    status: t('Selesai', 'Completed') as any,
    type: t('Komersial', 'Commercial'),
    units: '2',
    year: '2014',
    imageColor: 'bg-neutral-100'
  },
  // FASE III - KONSOLIDASI & PREMIUM CLUSTER (2015-2022)
  {
    title: 'Graha Padma Rimbo Panjang',
    location: 'Rimbo Panjang, Kampar',
    status: t('Selesai', 'Completed') as any,
    type: t('Rumah Premium', 'Premium Residence'),
    units: '217',
    year: '2015',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Graha Padma Raya',
    location: 'Rimbo Panjang, Kampar',
    status: t('Selesai', 'Completed') as any,
    type: t('Rumah Premium', 'Premium Residence'),
    units: '159',
    year: '2019',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Graha Padma Rimbo Panjang 2',
    location: 'Rimbo Panjang, Kampar',
    status: t('Selesai', 'Completed') as any,
    type: t('Rumah Premium', 'Premium Residence'),
    units: '55',
    year: '2019',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Graha Padma Rimbo Panjang 3',
    location: 'Rimbo Panjang, Kampar',
    status: t('Selesai', 'Completed') as any,
    type: t('Rumah Premium', 'Premium Residence'),
    units: '56',
    year: '2022',
    imageColor: 'bg-neutral-100'
  },
  // PROYEK BERJALAN (ONGOING)
  {
    title: 'Graha Padma Raya 2',
    location: 'Rimbo Panjang, Kampar',
    status: t('Berjalan', 'Ongoing') as any,
    type: t('Rumah Premium', 'Premium Residence'),
    units: '56',
    year: '2023',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Royal Pasir Putih',
    location: 'Kampar, Riau',
    status: t('Berjalan', 'Ongoing') as any,
    type: t('Rumah Premium', 'Premium Residence'),
    units: '19',
    year: '2023',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'Royal Pasir Putih (Ruko)',
    location: 'Kampar, Riau',
    status: t('Berjalan', 'Ongoing') as any,
    type: t('Komersial', 'Commercial'),
    units: '6',
    year: '2023',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'GRAPARI 4',
    location: 'Pekanbaru, Riau',
    status: t('Berjalan', 'Ongoing') as any,
    type: t('Rumah Premium', 'Premium Residence'),
    units: '48',
    year: '2024',
    imageColor: 'bg-neutral-100'
  }, {
    title: 'The Royal Padma',
    location: 'Pekanbaru, Riau',
    status: t('Berjalan', 'Ongoing') as any,
    type: t('Rumah Premium', 'Premium Residence'),
    units: '12',
    year: '2024',
    imageColor: 'bg-neutral-100'
  }];
  const filteredProjects = filter === t('Semua', 'All') ? projects : projects.filter(p => {
    if (filter === t('Berjalan', 'Ongoing')) {
      return p.status === t('Berjalan', 'Ongoing');
    }
    return p.type === filter;
  });
  return <div className="pt-20 min-h-screen bg-neutral-50" data-id="element-925">
      <SEOSchema type="projects" title={t('Portofolio Proyek | PT Graha Riau Gemilang', 'Project Portfolio | PT Graha Riau Gemilang')} description={t('Portofolio lengkap 26+ proyek PT Graha Riau Gemilang dengan 1774+ unit properti. Pengalaman 20+ tahun mengembangkan hunian subsidi, premium, dan komersial di Riau sejak 2005.', 'Complete portfolio of 26+ projects by PT Graha Riau Gemilang with 1774+ property units. 20+ years of experience developing subsidized, premium, and commercial properties in Riau since 2005.')} breadcrumbs={[{
      name: t('Beranda', 'Home'),
      url: 'https://grahariaugemilang.com/'
    }, {
      name: t('Portofolio Proyek', 'Project Portfolio'),
      url: 'https://grahariaugemilang.com/proyek'
    }]} data-id="element-926" />

      <div className="bg-white py-16 border-b border-premium" data-id="element-927">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-928">
          <h1 className="text-4xl font-bold text-gray-900 mb-4 heading-premium" data-id="element-929">
            {t('Portofolio Proyek', 'Project Portfolio')}
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8" data-id="element-930">
            {t('Lebih dari 20 tahun pengalaman mengembangkan properti berkualitas di Riau dengan 26+ proyek dan 1774+ unit properti.', 'Over 20 years of experience developing quality properties in Riau with 26+ projects and 1774+ property units.')}
          </p>

          {/* Statistics - Premium Elegant Design */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto mb-8" data-id="element-931">
            <div className="bg-white p-6 rounded-xl border border-premium shadow-premium hover:shadow-premium-lg transition-all" data-id="element-932">
              <Award className="w-8 h-8 text-[#C4161C] mx-auto mb-2" data-id="element-933" />
              <div className="text-3xl font-bold text-gray-900 mb-1" data-id="element-934">20+</div>
              <div className="text-sm font-semibold text-gray-700 mb-1" data-id="element-935">
                {t('Tahun Pengalaman', 'Years of Experience')}
              </div>
              <div className="text-xs text-gray-500" data-id="element-936">
                {t('Sejak berdiri tahun 2005 hingga kini', 'Established in 2005 and growing consistently')}
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl border border-premium shadow-premium hover:shadow-premium-lg transition-all" data-id="element-937">
              <Briefcase className="w-8 h-8 text-[#C4161C] mx-auto mb-2" data-id="element-938" />
              <div className="text-3xl font-bold text-gray-900 mb-1" data-id="element-939">26+</div>
              <div className="text-sm font-semibold text-gray-700 mb-1" data-id="element-940">
                {t('Proyek Selesai', 'Completed Projects')}
              </div>
              <div className="text-xs text-gray-500" data-id="element-941">
                {t('Di berbagai lokasi strategis Riau', 'Across strategic locations in Riau')}
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl border border-premium shadow-premium hover:shadow-premium-lg transition-all" data-id="element-942">
              <Home className="w-8 h-8 text-[#C4161C] mx-auto mb-2" data-id="element-943" />
              <div className="text-3xl font-bold text-gray-900 mb-1" data-id="element-944">1774+</div>
              <div className="text-sm font-semibold text-gray-700 mb-1" data-id="element-945">
                {t('Unit Properti', 'Property Units Delivered')}
              </div>
              <div className="text-xs text-gray-500" data-id="element-946">
                {t('Hunian dan properti komersial', 'Residential and commercial developments')}
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl border border-premium shadow-premium hover:shadow-premium-lg transition-all" data-id="element-947">
              <Building className="w-8 h-8 text-[#C4161C] mx-auto mb-2" data-id="element-948" />
              <div className="text-3xl font-bold text-gray-900 mb-1" data-id="element-949">12+</div>
              <div className="text-sm font-semibold text-gray-700 mb-1" data-id="element-950">
                {t('Mitra Perbankan', 'Banking Partners')}
              </div>
              <div className="text-xs text-gray-500" data-id="element-951">
                {t('Bank nasional & syariah terpercaya', 'Leading national and sharia banks')}
              </div>
            </div>
          </div>

          {/* Filters */}
          <div className="flex flex-wrap justify-center gap-2" data-id="element-952">
            {filters.map(f => <Button key={f} variant={filter === f ? 'primary' : 'outline'} onClick={() => setFilter(f)} className={filter === f ? '' : 'border-gray-300 text-gray-600 hover:border-[#C4161C] hover:text-[#C4161C]'} data-id="element-953">
                {f}
              </Button>)}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-954">
        {/* Results count */}
        <div className="mb-6" data-id="element-955">
          <p className="text-gray-600" data-id="element-956">
            {t('Menampilkan', 'Showing')}{' '}
            <span className="font-bold text-gray-900" data-id="element-957">
              {filteredProjects.length}
            </span>{' '}
            {t('proyek', 'projects')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-958">
          {filteredProjects.map((project, index) => <ProjectCard key={index} {...project} data-id="element-959" />)}
        </div>

        {filteredProjects.length === 0 && <div className="text-center py-16" data-id="element-960">
            <p className="text-gray-500 text-lg" data-id="element-961">
              {t('Tidak ada proyek yang sesuai dengan filter.', 'No projects match the selected filter.')}
            </p>
          </div>}
      </div>

      {/* Phase Timeline Section - Premium Design */}
      <div className="bg-white py-16 border-t border-premium" data-id="element-962">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-963">
          <div className="text-center mb-12" data-id="element-964">
            <h2 className="text-3xl font-bold text-gray-900 mb-4 heading-premium" data-id="element-965">
              {t('Perjalanan Pengembangan', 'Development Journey')}
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-966">
              {t('Dari perintisan hunian subsidi hingga pengembangan premium cluster terintegrasi.', 'From pioneering subsidized housing to developing integrated premium clusters.')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-967">
            <div className="bg-white p-8 rounded-2xl border border-premium shadow-premium hover:shadow-premium-lg transition-all" data-id="element-968">
              <div className="text-sm font-bold text-gray-500 mb-2" data-id="element-969">
                {t('FASE I', 'PHASE I')} • 2005–2010
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-970">
                {t('Perintisan & Hunian Subsidi', 'Pioneering & Subsidized Housing')}
              </h3>
              <div className="text-3xl font-bold text-[#C4161C] mb-2" data-id="element-971">
                1.081
              </div>
              <p className="text-sm text-gray-600" data-id="element-972">
                {t('unit hunian subsidi berkualitas di Pekanbaru & Kampar', 'quality subsidized housing units in Pekanbaru & Kampar')}
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl border border-premium shadow-premium hover:shadow-premium-lg transition-all" data-id="element-973">
              <div className="text-sm font-bold text-gray-500 mb-2" data-id="element-974">
                {t('FASE II', 'PHASE II')} • 2011–2014
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-975">
                {t('Ekspansi & Diversifikasi', 'Expansion & Diversification')}
              </h3>
              <div className="text-3xl font-bold text-[#C4161C] mb-2" data-id="element-976">220+</div>
              <p className="text-sm text-gray-600" data-id="element-977">
                {t('unit hunian premium, ruko, kios, dan hotel', 'premium residences, shop houses, kiosks, and hotel rooms')}
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl border border-premium shadow-premium hover:shadow-premium-lg transition-all" data-id="element-978">
              <div className="text-sm font-bold text-gray-500 mb-2" data-id="element-979">
                {t('FASE III', 'PHASE III')} • 2015–2024
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-980">
                {t('Premium Cluster & Ongoing', 'Premium Clusters & Ongoing')}
              </h3>
              <div className="text-3xl font-bold text-[#C4161C] mb-2" data-id="element-981">628</div>
              <p className="text-sm text-gray-600" data-id="element-982">
                {t('unit hunian premium terintegrasi di Rimbo Panjang & Pekanbaru', 'integrated premium housing units in Rimbo Panjang & Pekanbaru')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}